import { Box, MediaBox, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { SubMenuElement } from "areas/helpdesk/index"

const Dropdown = styled.label`
  display: inline-block;
  position: relative;
  width: 100%;
`
const DdButton = styled(Box)`
  background-color: #ffffff;
  border: 1px solid gray;
  cursor: pointer;
  display: inline-block;
  padding: 10px 30px 10px 20px;
  white-space: nowrap;
  width: 100%;
  :after {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid black;
    content: "";
    height: 0;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
  }
`

const DdInput = styled.input`
  display: none;
  :checked + div {
    display: block;
  }
`
const DdMenu = styled.div`
  background-color: #ffffff;
  border: 1px solid #ccc;
  display: none;
  list-style-type: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 100%;
  width: 100%;
`
const DdMenuTitle = styled(Typography).attrs({
  color: "black",
  display: "block",
  fontSize: 18,
  fontWeight: "bold",
  mb: 1,
})`
  ${(props) => props.theme.helpdesk.ddMenuTitle}
`

const ExpandMenu = ({ match, results }) => {
  const collectionIds = Object.keys(results)
  return (
    <Box contain>
      <MediaBox lessThan="tablet" px={8}>
        <Dropdown>
          <DdButton>Please Select ...</DdButton>
          <DdInput type="checkbox" />

          <DdMenu>
            <Box px={3} py={2}>
              {collectionIds.map((collectionId, index) => (
                <SubMenuElement
                  collectionData={results}
                  collectionId={collectionId}
                  expanded={
                    match.params && match.params.collection_id == collectionId
                  }
                  key={`submenu_${index}`}
                />
              ))}
            </Box>
          </DdMenu>
        </Dropdown>
      </MediaBox>

      <MediaBox greaterThanOrEqual="tablet">
        <DdMenuTitle as={Link} data-lc="expandMenu" to="/helpdesk">
          Home
        </DdMenuTitle>
        {collectionIds.map((collectionId, index) => (
          <SubMenuElement
            collectionData={results}
            collectionId={collectionId}
            expanded={
              match.params && match.params.collection_id == collectionId
            }
            key={`submenu_${index}`}
          />
        ))}
      </MediaBox>
    </Box>
  )
}

ExpandMenu.propTypes = {
  match: PropTypes.object,
  results: PropTypes.object,
}

export default ExpandMenu
